import React, { memo } from 'react';
import { View } from 'react-native';
import Amount from 'design-system/Amount';
import Text from 'design-system/Text';
import { CardView, ProgressBar, Spacer, ToolTip } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectTradingAccount } from '../reducers/selectors';
import { IsaAllowanceFormatted, IsaAllowanceNumeric } from '../constants';
const strings = {
    isaAllowance: 'ISA allowance',
    isaAllowanceLeft: 'ISA allowance left',
    basedOnThisYear: 'Based on this tax year',
};
const legacyIsaAllowanceDescription = [
    <Text TextThin-14 Secondary key="1">
    Each tax year, you can pay into one of each type of ISA (we offer a Flexible Stocks & Shares ISA). You can invest up
    to{' '}
    <Text NumbersThin-14 Secondary>
      {IsaAllowanceFormatted}
    </Text>{' '}
    in total across all your ISAs, either in one ISA or split between different types.
  </Text>,
    `With a Flexible ISA, you can withdraw and replace money within the same tax year without affecting your allowance, as long as you stay within the ${IsaAllowanceFormatted} limit.`,
    'Any money kept within an ISA remains tax-free. The tax year runs from 6 April to 5 April.',
    'If you’ve contributed to ISAs outside Emma this tax year, this may not reflect your annual remaining ISA allowance.',
];
const ISAAllowanceInfo = () => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const remainingAllowance = tradingAccount?.account.accountType === 'ISA'
        ? tradingAccount?.account.isaRemainingAllowanceAfterPending
        : undefined;
    if (!remainingAllowance) {
        return null;
    }
    const effectiveValue = Math.max(0, remainingAllowance.value);
    const progress = Math.max(0, 1 - effectiveValue / IsaAllowanceNumeric);
    return (<CardView noMarginTop withPadding>
      <View style={styles.row}>
        <Text Text-16 flex>
          {strings.isaAllowanceLeft}
        </Text>
        <Amount Numbers-16 value={{ value: effectiveValue, currency: 'GBP' }}/>
      </View>
      <Spacer h={8}/>
      <ProgressBar animateInitial={false} animateProgress={false} position={progress * 100} colors={colors.gradients.ultimate.colors}/>
      <Spacer h={8}/>
      <View style={styles.row}>
        <Text TextThin-14 Secondary>
          {strings.basedOnThisYear}
        </Text>
        <Spacer w={4}/>
        <ToolTip small offset={1} colorKey="secondary" title={strings.isaAllowance} subtitle={legacyIsaAllowanceDescription}/>
      </View>
    </CardView>);
};
const styleSet = createStyleSheets(() => ({
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
}));
export default memo(ISAAllowanceInfo);
